
import { Injectable } from '@angular/core';
import { Http, RequestOptions, Headers, } from '@angular/http';
import { ConfigureServiceProvider } from '../configure-service/configure-service';
//@santhiya added to handle api from one file
import { ConfigApiServiceProvider } from '../config-api-service/config-api-service';
import * as uuid from 'uuid';

// declare var jQuery: any;
let rootFolder;// = Object.assign({},this.getFO);
let sharedRootFolder;

@Injectable()
export class StoreWrapProvider {
  typeOfData = {
    typeFolder: 0,
    typeFile: 1,
    typeTemplate: 2,
    typeFilterParams: 3,
    typeCustomApi: 4,
    typeAssignTemplate: 5,
    typeSmartFolder: 6,
    typeRootFolder: 7,
    typeTraverseFolder: 8,
    typePostCustomApi: 9,
    typeSharedRootFolder: 10,
    typeSharedFolder: 11,
    typeSharedFile: 12,
    typePostTemplateHistoryApi: 13,
    typeRenameFolder: 14,
    typeRenameSharedFolder: 15,
    typeDeleteFolder: 16,
    typeDeleteSharedFolder: 17,
    typeSharedSmartFolder: 18,
    typeShareInfoFolder: 19,
    typeCopyFolder: 20,
    typeMoveFolder: 21,
    typeFolderProperty: 22
  }

  statusOfData = {
    received: 0,
    saveSuccess: 1,
    saveFailed: -1
  }

  typeOfApi = {
    summary: 'summary',
    customSummary: 'customSummary',
    postadd: 'postadd',
    fieldproperties: 'fieldproperties'
  }
  host: string;
  summaryApi: string;
  postaddApi: string;
  fieldApi: string;
  pullFolder: string;
  pushFolder: string;

  licenceClientDB: any = {
    "client": "eprodcast"
  };
  //@santhiya commented to get api request from config api provider component
  /*
  driveApi = {
    'pullData' : {"api":this.configureService.getHost() +'summary/',"params":{"userid": "","rptname":"","client":""}},
    'pushData' : {"api":this.configureService.getHost() +'postadd/',"params":{"userid": "","rptname":"","client":"HRSP74950"}},
    'properties': {"api":this.configureService.getHost() +'GetFieldProperties/',"params":{"userid": "","rptname":"","client":"HRSP74950"}},
    // 'pullFolder' : {"api":this.configureService.getHost() +'pullFolder/',"params":{"userid": "","rptname":"User_Settings599","client":"HRSP74950","drive":"root"}},
    // 'pushFolder' : {"api":this.configureService.getHost() +'pushFolder/',"params":{"userid": "","rptname":"User_Settings599","client":"HRSP74950","action":"","folder":"","drive":"root"}}
    // @santhiya changed above to get pullFolder and pushFolder api from driveConfiguration screen
     'pullFolder' : {"api":this.configureService.getHost() +'pullFolder/',"params":this.configApiService.driveApi.pullFolder},
    'pushFolder' : {"api":this.configureService.getHost() +'pushFolder/',"params":this.configApiService.driveApi.pushFolder}
  }
*/
  //
  storeTemplates: any = {};

  // current folder data 
  objCurrentFolders: any;
  objCurrentFiles: any;
  objCurrentTemplates: any;
  objCurrentFolder: any;  // always refer to the current visible folder
  objFilterParams: any;
  // objFolderActionConfig = {      
  //   "Sender_User_ID":"",
  //   "Receiver_User_ID": "",
  //   "Sender_App_Code":"",
  //   "Shared_Folder_Json":"",
  //   "ShareType":"",
  //   "User_Folder_Json": "",
  //   "Status":"Edit",
  //   "userid": "",
  //   "rptname":"User_Settings599",
  //   "client":"HRSP74950"
  // }        

  constructor(private _http: Http, public configureService: ConfigureServiceProvider, public configApiService: ConfigApiServiceProvider) {
    console.log('Hello StoreWrapProvider Provider');
    // var data = this.getJson();
    this.host = this.configureService.getHost();
    this.summaryApi = this.host + 'summary/';
    this.postaddApi = this.host + 'postadd/';
    this.fieldApi = this.host + 'GetFieldProperties/';
    this.pullFolder = this.host + 'pullfolder/';
    this.pushFolder = this.host + 'pushFolder/';
    sharedRootFolder = Object.assign({}, this.getFolderStructure(), { 'name': 'Share' });
    rootFolder = Object.assign({}, this.getFolderStructure(), { 'name': 'Drive' });
  }

  getFolderStructure() {
    return {
      "name": '',
      "index": 0,
      "parent_folder_id": 0,
      "folder_id": -1,
      "date_modified": '',
      "type": "Folder",
      "Size": "",
      "author": "",
      "Client": "",
      "sync": false,
      "folder_type": "folder,virtual_folder,file",
      "path": [],
      "folders": [],
      "template": [
        {
          'id': '',
          'templateName': '',
          'componentName': '',
          'pullParams': {},
          'pushParams': {},
          'filterParams': {},
          'sourceKey': {},
          'accessType': '',
          'colprops': []
        }
      ],
      "files": [[]],
      "rpt_retrieve": [
        {
          "rptname": "Billing_Header66",
          "template": ""
        }
      ]
    };
  }

  getJson() {
    // return  this._http.get(this._baseUrl + jsonFileName + '.json');
    return new Promise((resolve, reject) => {
      const url = '../../assets/object/folderObject.json';
      return this._http.get(url)
        .subscribe(data => {
          resolve(data.json());
        }, (err) => {
          console.log('error:get-config:', err);
          reject(null);
        });
    });
  }


  public copyFolder(destfolder, srcfolder) {
    destfolder = Object.assign(destfolder, srcfolder)
    destfolder.folder_id = uuid.v4();
    destfolder.path = [...srcfolder.path];
    destfolder.path.push(srcfolder.parent_folder_id);
    destfolder.folders = [];
    srcfolder.folders.forEach(nxtSrcFolder => {
      // let nextDestFolder = Object.assign( {}, this.getFolderStructure(), nxtSrcFolder);
      // nextDestFolder.parent_folder_id = destfolder.folder_id;

      destfolder.folders.push(this.copyFolder(this.getFolderStructure(), nxtSrcFolder));
    });
    return destfolder;
  }

  private traverseToFolder(parentFolder, path, depthIdx) {
    let folderID = path[depthIdx];
    let fidx = {};

    fidx = parentFolder.folders.find(function (fid) {
      return fid.folder_id === folderID;
    });

    console.log('fid', fidx);
    if (depthIdx >= path.length - 1) {
      return fidx;
    } else {
      return this.traverseToFolder(fidx, path, ++depthIdx);
    }
  }

  private getRootFolder() {
    return rootFolder;
  }

  private clearRootFolder() {
    rootFolder = this.getFolderStructure();
    return rootFolder;
  }

  private getShareRootFolder() {
    return sharedRootFolder;
  }

  // private clearShareRootFolder() {
  //   sharedRootFolder = Object.assign({}, this.getFolderStructure(), { 'name': 'Share' });;
  //   return sharedRootFolder;
  // }

  public createFolder(parentFolder, folderName, folderData) {
    let thisFolder = this.getFolderStructure();
    // Object.assign(thisFolder, this.folderSt)
    let maxProgressStatus = 0;

    thisFolder.folder_id = uuid.v4();
    maxProgressStatus = maxProgressStatus + 1;
    thisFolder.name = folderName;
    // thisFolder.files = folderData; // RAJ - Commenting out for a empty structure issue 
    thisFolder.parent_folder_id = parentFolder.folder_id;

    if (!thisFolder.parent_folder_id) { // root folder
      thisFolder.path.push(0);
      rootFolder.folders.push(thisFolder);
    } else {
      thisFolder.path = [...parentFolder.path];
      thisFolder.path.push(thisFolder.parent_folder_id);
      parentFolder.folders.push(thisFolder);
    }
    return thisFolder;
  }

  private createShareFolder(parentFolder, folderName, folderData) {
    let thisFolder = this.getFolderStructure();
    // Object.assign(thisFolder, this.folderSt)
    let maxProgressStatus = 0;
    thisFolder.folder_id = parentFolder.folder_id;
    maxProgressStatus = maxProgressStatus + 1;
    thisFolder.name = parentFolder.name;
    thisFolder.type = folderName;
    thisFolder.folders = parentFolder.folders;
    thisFolder.files = parentFolder.files;
    // thisFolder.sourcePath = parentFolder.path;
    thisFolder.parent_folder_id = parentFolder.parent_folder_id;
    thisFolder.template = parentFolder.template;

    // if(!thisFolder.parent_folder_id) { // root folder
    thisFolder.path.push(0);
    //   rootFolder.folders.push(thisFolder);      
    // } else {
    //   thisFolder.path = [...parentFolder.path];
    //   thisFolder.path.push(thisFolder.parent_folder_id);
    //   parentFolder.folders.push(thisFolder);
    // }
    console.log(thisFolder);
    return thisFolder;
  }

  private createSmartFolder(smartFolder, folderName, filterParams) {
    let thisFolder = Object.assign({}, this.getFolderStructure(), { 'name': 'Drive' });


    let maxProgressStatus = 0;

    thisFolder.folder_id = uuid.v4();
    maxProgressStatus = maxProgressStatus + 1;
    thisFolder.name = folderName;
    thisFolder.parent_folder_id = smartFolder.folder_id;
    thisFolder.template = [];
    for (let idx = 0; idx < smartFolder.template.length; idx++) {
      let template: any = {};
      // let __self = this;
      Object.keys(smartFolder.template[idx]).forEach(key => {
        template[key] = smartFolder.template[idx][key];
      });
      thisFolder.template.push(template);
    }

    if (thisFolder.template.length) {

      thisFolder.template[0].filterParams = Object.assign({}, thisFolder.template[0].filterParams, filterParams)
    }

    if (!thisFolder.parent_folder_id) { // root folder
      thisFolder.path.push(0);
      rootFolder.folders.push(thisFolder);
    } else {
      thisFolder.path = [...smartFolder.path];
      thisFolder.path.push(thisFolder.parent_folder_id);
      smartFolder.folders.push(thisFolder);
    }
    return thisFolder;
  }

  createSharedFile(ffdataRef, folderData, fileData) {
    let thisFolder = Object.assign({}, this.getFolderStructure(), { 'name': 'Share' });
    thisFolder.files = fileData.files;
    thisFolder.template = fileData.template;
    return thisFolder;
  }

  // private deleteFolder(parent_folder_id) {    
  // }

  // private renameFolder(parent_folder_id, folderName, folderData) {
  // }

  // private modifyFile(folder, fileInfo) {
  //   return folder;
  // }

  private createFile(folder, files) {
    folder['files'].push(files);
    return folder;
  }

  // private deleteFile(fileID, folderID) {
  // }

  // private renameFile(fileID, fileName, fileData) {
  // }

  // private getFolderContent(folderID, folderData, filterCriteria) {
  //   return [];
  // }

  private cleanupTemplates(folder): any {
    let arrTemplates: any = [];
    for (let idxTemplate = 0; idxTemplate < folder['template'].length; idxTemplate++) {
      /////////New Code/////////
      // console.log(folder,idxTemplate)
      if (folder['template'][idxTemplate]) {
        if (folder['template'][idxTemplate]['id'] && folder['template'][idxTemplate]['filterParams']) {
          ///////added lines///////
          arrTemplates.push({ id: folder['template'][idxTemplate]['id'], filterParams: folder['template'][idxTemplate]['filterParams'] });
        }
      }
    }

    return arrTemplates;
  }

  private handleFolderPushData(folder) {
    folder['files'] = [];
    let __self = this;
    folder['template'] = __self.cleanupTemplates(folder);
    if (folder['folders'].length > 0) {
      folder['folders'].map(function (rootFolders) {
        rootFolders['files'] = [];
        rootFolders['template'] = __self.cleanupTemplates(rootFolders);
        if (rootFolders['folders'].length > 0) {
          rootFolders['folders'].map(function (SubFolders) {
            SubFolders['files'] = [];
            SubFolders['template'] = __self.cleanupTemplates(SubFolders);
            if (SubFolders['folders'].length > 0) {
              SubFolders['folders'].map(function (folders) {
                folders['files'] = [];
                folders['template'] = __self.cleanupTemplates(folders);
              });
            }
          });
        }
      });
    }
    return folder;
  }

  private assignTemplate(rootFolder, templateconfig, currentFolder, storeLocalCallback, synccallback) {
    let rootFolderId = currentFolder['path'].length;
    if (rootFolderId <= 1) {
      rootFolderId = this.objCurrentFolder.folder_id;
    } else {
      rootFolderId = this.objCurrentFolder['path'][1];
    }


    /* RAJ - Commented out for template saving to wrong folder bug. not sure about the purpose of below code
    let currentRootFolder;

    for(let i=0; i < rootFolder['folders'].length; i++){ 
      if(rootFolder['folders'][i].folder_id === rootFolderId){
        currentRootFolder = rootFolder['folders'][i];
        folder_Json = rootFolder['folders'][i];
      }
    } 
    */
    let folder_Json;
    folder_Json = this.handleFolderPushData(currentFolder);

    if (templateconfig) {

      // commenting out and fixing for multi template assignment
      currentFolder['template'] = templateconfig;
      /*
     if( currentFolder['template'].length ) {
      currentFolder['template'][0] = templateconfig;
     } else {
      currentFolder['template'].push(templateconfig);
     }
     */
      storeLocalCallback(currentFolder);
      let params = Object.assign({}, this.configApiService.driveApi.pushFolder.params, this.licenceClientDB, { "userid": this.configureService.getLoginUserID(), "folder": folder_Json, "action": "update", "appCode": this.configApiService.currentDriveApp['app_code'] });
      this.epcDriveConect(this.pushFolder, params, synccallback);
    } else {
      alert("template config invalid !!")
    }


  }

  /******
   * LOAD FOLDER EXTRA PROPERTIES
   * ***** */
  private updateFolderProperties(rootFolder, ffdata, currentFolder, storeLocalCallback, synccallback) {
    let rootFolderId = currentFolder['path'].length;
    if (rootFolderId <= 1) {
      rootFolderId = this.objCurrentFolder.folder_id;
    } else {
      rootFolderId = this.objCurrentFolder['path'][1];
    }
    let folder_Json;
    // currentFolder = Object.assign({},currentFolder,ffdata);
    folder_Json = this.handleFolderPushData(currentFolder);
    storeLocalCallback(currentFolder);
    let params = Object.assign({}, this.configApiService.driveApi.pushFolder.params, { "userid": this.configureService.getLoginUserID(), "folder": folder_Json, "action": "update", "appCode": this.configApiService.currentDriveApp['app_code'] });
    this.epcDriveConect(this.pushFolder, params, synccallback);
  }

  private srtingifyDataForEpc(json): string {
    let obj = { data: JSON.stringify(json) };
    let pdata = JSON.stringify(obj);
    return pdata;
  }

  /* * * * * *
  * Handle response summary data  
  * * * * * */
  private handleSummaryData(data, callback) {
    if (data["_POST_SummaryMethodResult"].length > 0) {
      if (data["_POST_SummaryMethodResult"] !== "FAIL") {
        if (this.objCurrentFolder != null) {
          this.objCurrentFolder['files'] = [];
        }
        this.objCurrentFolder = this.createFile(this.objCurrentFolder, JSON.parse(data["_POST_SummaryMethodResult"]));
      }
    } else {
      this.objCurrentFolder['files'];
    }
    callback(this.objCurrentFolder['files']);
  }

  /* * * * * *
  * Handle  response custom summary data  
  * * * * * */
  private handleCustomSummaryData(data, callback) {
    let currentdata;
    if (data["_POST_SummaryMethodResult"].length > 0) {
      if (data["_POST_SummaryMethodResult"] !== "FAIL") {
        currentdata = JSON.parse(data["_POST_SummaryMethodResult"])
      }
    } else {
      currentdata;
    }
    callback(currentdata);
  }

  /* * * * * *
  * Handle response summary data  
  * * * * * */
  private handleFiledPropertiesData(data, callback) {
    if (data["_POST_FieldPropertyMethodResult"].length > 0) {
      if (data["_POST_FieldPropertyMethodResult"] !== "FAIL") {
        this.objCurrentFiles = [];
        this.objCurrentFiles = data["_POST_FieldPropertyMethodResult"];
      }
    } else {
      this.objCurrentFiles = [];
    }
    callback(this.objCurrentFiles);
  }

  /* * * * * *
  * Handle response summary data  
  * * * * * */
  private handlePostAddData(data, callback) {
    if (data["_POST_AddMethodResult"].length > 0) {
      var _data = {};
      var _responseData = data["_POST_AddMethodResult"][0];
      _data['Result'] = _responseData.Result;
      _data['Message'] = _responseData.Message;
      if (_responseData.Result == "SUCCESS") {
        var ref = _responseData.Ref_ID;
        if (ref) {
          ref = eval("(" + ref + ")");
          for (var m in ref) {
            _data = Object.assign({}, _data, ref[m]);
          }
        }
      } else if (_responseData.Result == "FAILED" || _responseData.Result == "FAIL") {
        if (_responseData.Message) {
          _data = Object.assign({}, _data, JSON.parse(_responseData.Message));
        } else {
          _data['Result'] = _responseData.Result;
          _data['Message'] = 'Record Saved Failed!.Please try again..'
        }
        callback(_data);
      }
    } else {
      this.objCurrentFiles
    }
    callback(_data);
  }

  /******
  method: postApi() 
  description: 
  params:
    api: summary / postadd / fieldproperties /
    host: eg: https://time.starport.ca/epc_v3.svc
    params: reserved for future use
    data: data to be used in body, 
    callback: method to be called on successful request
  */
  private postApi(typeOfApi, host, params, callback) {
    let headers = this.configApiService.setHeaders();
    let options = new RequestOptions({ headers: headers });
    return new Promise((resolve, reject) => {
      return this._http.post(host, this.srtingifyDataForEpc(params), options)

        .map(res => res.json())
        .subscribe(data => {

          if (typeOfApi === this.typeOfApi.summary) {
            this.handleSummaryData(data, callback);
          }
          else if (typeOfApi === this.typeOfApi.customSummary) {
            this.handleCustomSummaryData(data, callback);
          }
          else if (typeOfApi === this.typeOfApi.fieldproperties) {
            this.handleFiledPropertiesData(data, callback);
          }
          else if (typeOfApi === this.typeOfApi.postadd) {
            this.handlePostAddData(data, callback);
          } else {
            callback(data);
          }
        }, (err) => {
          console.log('error:apps:', err);
          reject(null);
        });
    });
  }

  private epcDriveConect(host, params, callback) {
    let headers = this.configApiService.setHeaders();
    let options = new RequestOptions({ headers: headers });
    params = Object.assign({}, params, { "userid": this.configureService.getLoginUserID() });

    // if (this.configApiService.currentDriveApp['app_code']) {
    //   params = Object.assign({}, params, { "appCode": this.configApiService.currentDriveApp['app_code'] });
    // }

    // if (this.configApiService.currentDriveApp['StudioAppCode']) {
    //   params = Object.assign({}, params, { "client": this.configApiService.currentDriveApp['StudioAppCode'] });
    // }

    if (params.hasOwnProperty('appCode') == false || !params['appCode']) {
      if (this.configApiService.currentDriveApp['app_code']) {
        params = Object.assign({}, params, { "appCode": this.configApiService.currentDriveApp['app_code'] });
      }
    }

    if (params.hasOwnProperty('client') == false || !params['client']) {
      if (this.configApiService.currentDriveApp['StudioAppCode']) {
        params = Object.assign({}, params, { "client": this.configApiService.currentDriveApp['StudioAppCode'] });
      }
    }
    return new Promise((resolve, reject) => {
      return this._http.post(host, this.srtingifyDataForEpc(params), options)

        .map(res => res.json())
        .subscribe(data => {
          callback(data);
        }, (err) => {
          console.log('error:apps:', err);
          reject(null);
        });
    });
  }


  private constructFilterQuery(key, filterType, type, filter): any {
    let filterStr = '';
    switch (filterType) {
      case 'text': {
        if (type === 'contains') {
          filterStr = key + ' like \'\'%' + filter + '%\'\'';
        } else if (type === 'not contains') {
          filterStr = key + ' not like \'\'%' + filter + '%\'\'';
        } else if (type === 'equals') {
          filterStr = key + ' = \'\'' + filter + '\'\'';
        } else if (type === 'notEqual') {
          filterStr = key + ' != \'\'' + filter + '\'\'';
        } else if (type === 'starts with') {
          filterStr = key + ' like \'\'' + filter + '%\'\'';
        } else if (type === 'ends with') {
          filterStr = key + ' like \'\'%' + filter + '\'\'';
        }
        break;
      }
      case 'date': {
        if (type === 'equals') {
          filterStr = key + ' = \'\'' + filter + '\'\'';
        } else if (type === 'greater than') {
          filterStr = key + ' > \'\'' + filter + '\'\'';
        } else if (type === 'less than') {
          filterStr = key + ' <like> \'\'' + filter + '%\'\'';
        } else if (type === 'notEqual') {
          filterStr = key + ' != \'\'' + filter + '\'\'';
        } else if (type === 'in range') {
          filterStr = key + ' between \'\'' + filter + '\'\' and ' + '\'\'' + filter + '\'\'';
        }
        break;
      }
      case 'number': {
        if (type === 'equals') {
          filterStr = key + ' = ' + filter;
        } else if (type === 'notEqual') {
          filterStr = key + ' != ' + filter;
        } else if (type === 'less than') {
          filterStr = key + ' < ' + filter;
        } else if (type === 'less than or equals') {
          filterStr = key + ' <= ' + filter;
        } else if (type === 'greater than') {
          filterStr = key + ' > ' + filter;
        } else if (type === 'greater than or equals') {
          filterStr = key + ' >= ' + filter;
        } else if (type === 'in range') {
          filterStr = key + ' >= ' + filter + ' and =< ' + filter;
        }
        break;
      }
    }
    return filterStr;
  }

  private constructParams(params): any {
    if (Object.keys(params).length) {
      return JSON.stringify(params);
    }
    return '';
    let filterQry = '', filterType = '', filter = '', type = '', operator = '';
    let __this = this;
    Object.keys(params).forEach(function (key) {
      filterType = params[key]['filterType'];
      if (params[key]['operator']) {
        operator = params[key]['operator']
        type = params[key]['condition1']['type'];
        filter = params[key]['condition1']['filter'];
        filterQry = filterQry + __this.constructFilterQuery(key, filterType, type, filter);
        type = params[key]['condition2']['type'];
        filter = params[key]['condition2']['filter'];
        filterQry = filterQry + ' ' + operator + ' ' + __this.constructFilterQuery(key, filterType, type, filter);
      }
      else {
        type = params[key]['type'];
        filter = params[key]['filter'];
        filterQry = filterQry + __this.constructFilterQuery(key, filterType, type, filter);
      }

    })
    return filterQry;
  }

  /* * * * * *
  * pull folder files   
  * * * * * */
  // @prabha commented is not used
  // private pullFolderFilesData(ffdataRef, ffdata, currentFolder, api, type, callback) {
  //   let filesLength = currentFolder['files'];
  //   if (filesLength > 0) {
  //     this.objCurrentFiles = currentFolder["files"];
  //     callback(this.objCurrentFiles)
  //   } else {
  //     let template = currentFolder['template'];
  //     if (template.length > 0 && ffdataRef < template.length) {
  //       let templateParam = template[ffdataRef].pullParams;

  //       if (templateParam != undefined) {
  //         if (api === this.typeOfApi.summary) {
  //           let filterData = this.constructParams(template[ffdataRef]['filterParams']);//{...template[ffdataRef].pullParams, ...template[ffdataRef]['filterParams']};
  //           if (filterData !== '') {
  //             templateParam['filterData'] = filterData;
  //           }
  //           this.postApi(api, this.summaryApi, templateParam, callback)
  //         } else if (api === this.typeOfApi.fieldproperties) {
  //           this.postApi(api, this.fieldApi, templateParam, callback)
  //         }
  //       }
  //     }
  //   }
  // }

  private drivePullFolderFilesData(templateID, ffdata, currentFolder, callback) {
    let filesLength = currentFolder['files'];
    if (filesLength > 0) {
      this.objCurrentFiles = currentFolder["files"];
      callback(this.objCurrentFiles)
    } else {
      let pullParams = this.storeTemplates[templateID].pullParams;
      let templateIdx = currentFolder.template.findIndex(function (element, i) { return element.id === templateID });
      // code commeted by @prabha
      // let filterParams = currentFolder['template'][templateIdx]['filterParams'];
      // till
      let filterParams = (templateIdx === -1 ? {} : currentFolder['template'][templateIdx]['filterParams']);
      // let template = currentFolder['template'];  
      //if(template.length > 0 && ffdataRef < template.length){
      let templateParam = (JSON.parse(JSON.stringify(pullParams)));;
      if (templateParam != undefined) {
        let filterData = this.constructParams(filterParams);
        if (filterData !== '') {
          templateParam['filterData'] = filterData;
        }
        if (ffdata) {
          templateParam = Object.assign({}, templateParam, ffdata, { 'userid': this.configureService.getLoginUserID() });
        }
        templateParam = Object.assign({}, templateParam, { 'userid': this.configureService.getLoginUserID() });
        this.postApi(this.typeOfApi.summary, this.summaryApi, templateParam, callback)
      }
    }
    //}
  }

  /* * * * * *
  * pull Share File Data
  * * * * * */
  private pullShareFileData(ffdataRef, ffdata, currentFolder, api, type, callback) {
    let folder = this.createSharedFile(ffdataRef, this.objCurrentFolder, ffdata);
    callback(folder);
  }

  /* * * * * *
  * pull Share File Data
  * * * * * */
  private pullTemplates(callback) {
    // let ffdata = {"start":"1", "end":"100","userid":"3280", "rptname":"User_Settings629", "client":"HRSP74950"}
    //@ss changed 3280 user id to global user id
    // let userid = this.configureService.getLoginUserID();
    // let ffdata = {"start":"1", "end":"100","userid":userid, "rptname":"User_Settings629", "client":"HRSP74950"}
    //@santhiya commented above request to get from config api service
    if (!this.configApiService.currentDriveApp['StudioAppCode']) {
      this.configApiService.currentDriveApp['StudioAppCode'] = this.configApiService.driveApi.pullTemplates.params['client'];
    }
    let ffdata = Object.assign({}, this.configApiService.driveApi.pullTemplates.params, { "userid": this.configureService.getLoginUserID(), "app_code": this.configApiService.currentDriveApp['app_code'], "client": this.configApiService.currentDriveApp['StudioAppCode'] });
    // let ffdata=Object.assign({},this.configApiService.driveApi.pullTemplates.params,{"userid":this.configureService.getLoginUserID()});
    if (this.storeTemplates.length) {
      callback(this.storeTemplates);
    } else {
      this.postApi(this.typeOfApi.customSummary, this.summaryApi, ffdata, (templateData) => {
        templateData.forEach(element => {
          let template = JSON.parse(element.PluginData);
          template.id = template.id === 0 ? template.templateName : template.id
          template['category'] = element.Category;
          this.storeTemplates[template.id] = template;
        });
        callback(this.storeTemplates)
      }
      )
    }
  }



  /* * * * * *
  * pull filter params   
  * * * * * */
  //@prabha commented is not used
  // private pullFilterParams(ffdataRef, ffdata, currentFolder, api, type, callback) {
  //   let template = currentFolder['template'];
  //   if (template.length > 0 && ffdataRef < template.length) {
  //     this.objFilterParams = '';
  //     this.objFilterParams = (template[ffdataRef]['filterParams']);
  //     callback(this.objFilterParams)
  //   }
  // }

  private drivePullFilterParams(ffdataRef, currentFolder, callback) {
    let template = currentFolder['template'];
    if (template.length > 0 && ffdataRef < template.length) {
      this.objFilterParams = '';
      this.objFilterParams = (template[ffdataRef]['filterParams']);
      callback(this.objFilterParams)
    }
  }

  /* * * * * *
  * pull folders    
  * * * * * */
  //@prabha commented is not used
  // private pullFolderData(ffdataRef, ffdata, currentFolder, api, type, callback) {
  //   this.postApi(this.typeOfApi.summary, this.summaryApi, ffdata, callback)
  //   let filesLength = currentFolder['folders'];
  //   if (filesLength > 0) {
  //     this.objCurrentFolder["folders"] = currentFolder["folders"];
  //   } else {
  //     // if not found, get the template params for the folder                  
  //   }
  // }

  private drivepullFolderData(ffdata, currentFolder, callback) {
    this.postApi(this.typeOfApi.summary, this.summaryApi, ffdata, callback)
    let filesLength = currentFolder['folders'];
    if (filesLength > 0) {
      this.objCurrentFolder["folders"] = currentFolder["folders"];
    } else {
      // if not found, get the template params for the folder                  
    }
  }



  /* * * * * *
  * pull folders    
  * * * * * */
  private pullCustomApi(ffdataRef, ffdata, currentFolder, api, type, callback) {

    if (api === this.typeOfApi.summary) {

      this.postApi(api, this.summaryApi, ffdata, callback);

    } else if (api === this.typeOfApi.customSummary) {

      this.postApi(api, this.summaryApi, ffdata, callback);

    } else if (api === this.typeOfApi.fieldproperties) {
      // let template = currentFolder['template'][ffdataRef];
      let templateID = ffdataRef;
      if (this.storeTemplates[templateID]['fieldProperties']) {
        callback(this.storeTemplates[templateID]['fieldProperties']);
      } else {
        let template;
        if (!this.storeTemplates[templateID]) {
          let templateIdx = this.objCurrentFolder.template.findIndex(function (element, i) { return element.id === templateID });
          if (templateIdx === -1) {
            templateIdx = 0;
          }
          template = this.objCurrentFolder.template[templateIdx];
        } else {
          template = this.storeTemplates[templateID];
        }

        ffdata = template['fieldParams'];
        if (!ffdata) {
          ffdata = Object.assign({}, template.pullParams);
          delete ffdata['start']; delete ffdata['end'];
        }

        this.postApi(api, this.fieldApi, ffdata, (fldpropData: any) => {
          this.storeTemplates[template.id]['fieldProperties'] = fldpropData;
          callback(fldpropData);
        });
      }
      /*
      if(template.length > 0 && template[ffdataRef]['fieldProperties']){
        callback(template[ffdataRef]['fieldProperties']);
      } else {
        ffdata = template[ffdataRef]['fieldParams'];
        if( !ffdata ) {
          ffdata = Object.assign({},template[ffdataRef].pullParams);
          delete ffdata['start'];delete ffdata['end'];
        }

        this.postApi(api,this.fieldApi,ffdata,(fldpropData: any)=>{
          currentFolder['template'][ffdataRef]['fieldProperties'] = fldpropData;
          callback(fldpropData);
        });
      }
      */
      // this.postApi(api,this.fieldApi,ffdata,callback);
    } else if (type === this.typeOfData.typeCustomApi) {

      this.postApi(api, api, ffdata, callback);

    }
  }

  /* * * * * *
  * pull Root folders    
  * * * * * */
  private pullRootFolder(ffdataRef, ffdata, currentFolder, api, type, callback) {
    this.clearRootFolder();
    // let __self = this;
    let RootFolder = this.getRootFolder();
    if (RootFolder.folder_id === -1) {
      // ffdata = Object.assign({},{"client":"HRSP74950","rptname":"User_Settings599","userid":"3280","drive":"root"});
      //@ss changed 3280 user id to global user id
      // ffdata = Object.assign({},{"client":"HRSP74950","rptname":"User_Settings599","userid":this.configureService.getLoginUserID(),"drive":"root"});
      //@santhiya changed ffdata to get from configureApiService component
      ffdata = Object.assign({}, this.configApiService.driveApi.pullFolder.params, { "userid": this.configureService.getLoginUserID(), "appCode": this.configApiService.currentDriveApp['app_code'], "client": "eprodcast" });
      this.epcDriveConect(this.pullFolder, ffdata, (respData: any) => {
        let resultObj = respData["_POST_PullFolderResult"][0];
        if (resultObj["Result"] === "SUCCESS") {
          let folderResp = JSON.parse(resultObj["Ref_ID"]);
          rootFolder = folderResp['root'] === "" ? rootFolder : JSON.parse(folderResp['root']);
          sharedRootFolder = folderResp['shared'] === "" ? sharedRootFolder : JSON.parse(folderResp['shared']);
          callback(rootFolder);
        }

      });
    } else {
      callback(RootFolder);
    }

  }

  /* * * * * *
 * pull Root folders    
 * * * * * */
  private pullShareRootFolder(ffdataRef, ffdata, currentFolder, api, type, callback) {
    //  this.clearShareRootFolder();
    let RootFolder = this.getShareRootFolder();
    if (RootFolder.folder_id === 0) {
      // ffdata = Object.assign({},{"client":"HRSP74950","rptname":"User_Settings599","userid":"3280","drive":"root"});
      //@ss changed 3280 user id to global user id
      // ffdata = Object.assign({},{"client":"HRSP74950","rptname":"User_Settings599","userid":this.configureService.getLoginUserID(),"drive":"root"});
      //@santhiya changed ffdata to get from configureApiService component
      ffdata = Object.assign({}, this.configApiService.driveApi.pullShareFolder.params, { "userid": this.configureService.getLoginUserID(), "appCode": this.configApiService.currentDriveApp['app_code'] });
      this.epcDriveConect(this.pullFolder, ffdata, (respData: any) => {
        let resultObj = respData["_POST_PullFolderResult"][0];
        if (resultObj["Result"] === "SUCCESS") {
          let folderResp = JSON.parse(resultObj["Ref_ID"]);
          rootFolder = folderResp['shared'] === "" ? rootFolder : JSON.parse(folderResp['shared']);
          callback(rootFolder);
        }
      });
    } else {
      callback(RootFolder);
    }
  }

  public pullData(ffdataRef, ffdata, currentFolder, api, type, callback) {
    this.objCurrentFolder = currentFolder;
    if (type === this.typeOfData.typeFile) {
      this.drivePullFolderFilesData(ffdataRef, ffdata, currentFolder, callback);
    }
    else if (type === this.typeOfData.typeFilterParams) {
      this.drivePullFilterParams(ffdataRef, currentFolder, callback);
    }
    else if (type === this.typeOfData.typeFolder) {
      this.drivepullFolderData(ffdata, currentFolder, callback);
    }
    else if (type === this.typeOfData.typeSharedFolder) {
      this.pullCustomApi(ffdataRef, ffdata, currentFolder, api, type, callback);
      // this.pullShareFolder(ffdataRef, ffdata,currentFolder, api, type, callback); 
      //  this.pullFolderData(ffdataRef, ffdata,currentFolder, api, type, callback);
    }
    else if (type === this.typeOfData.typeSharedFile) {
      this.pullShareFileData(ffdataRef, ffdata, currentFolder, api, type, callback);
    }
    else if (type === this.typeOfData.typeTemplate) {
      this.pullTemplates(callback);
    }
    else if (type === this.typeOfData.typeCustomApi) {
      this.pullCustomApi(ffdataRef, ffdata, currentFolder, api, type, callback);
    }
    else if (type === this.typeOfData.typeRootFolder) {
      this.pullRootFolder(ffdataRef, ffdata, currentFolder, api, type, callback);
    }
    else if (type === this.typeOfData.typeSharedRootFolder) {
      this.pullShareRootFolder(ffdataRef, ffdata, currentFolder, api, type, callback);
    }
  }

  /* * * * * *
 * push folder files   
 * * * * * */
  private pushFolderFilesData(templateID, ffdata, currentFolder, type, storeLocalCallback, synccallback) {
    let pushParams: any;
    let api = this.postaddApi;
    // 0 is the first template index
    let templateCnt = currentFolder['files'].length;
    // conditon changed prabha for new record
    if (templateCnt >= 0) {

      let template = this.storeTemplates[templateID];
      pushParams = template.pushParams;
      if (template) {
        if (ffdata != undefined) {
          // templateParam = jQuery.extend({},template[ffdataRef].pushParams,ffdata);
          if (ffdata.hasOwnProperty('PushArray')) {
            pushParams = Object.assign({}, ffdata, { "rptname": pushParams['rptname'], "client": pushParams['client'], 'userid': this.configureService.getLoginUserID() });
          } else {
            pushParams = Object.assign({}, pushParams, ffdata, { 'userid': this.configureService.getLoginUserID() });
          }
        }

        api = template.pushApi ? template.pushApi : this.postaddApi;
        if (pushParams != undefined) {
          // conditon changed prabha for new record  
          if (templateCnt === 0) {
            this.objCurrentFolder['files'].push([]);
            this.objCurrentFolder['files'][0].push(ffdata);
          } else {
            this.objCurrentFolder['files'][0].push(ffdata);
          }
          storeLocalCallback(this.objCurrentFolder['files'])
          this.postApi(this.typeOfApi.postadd, api, pushParams, synccallback);
        }
      }
    }
  }

  /* * * * * *
  * push folder    
  * * * * * */
  private pushFolderData(rootFolder, ffdata, currentFolder, type, storeLocalCallback, synccallback) {
    let folder = ffdata;//
    let folderLength = folder['path'].length;
    let folder_Json: any;

    if (folderLength <= 1) {
      folder_Json = folder;
    } else if (folderLength <= 2) {
      folder_Json = this.objCurrentFolder;
    } else {
      let folderId = this.objCurrentFolder['path'][1];
      for (let i = 0; i < rootFolder['folders'].length; i++) {
        if (rootFolder['folders'][i].folder_id === folderId) {
          folder_Json = rootFolder['folders'][i];
        }
      }
    }
    // console.log(folder_Json);    
    folder_Json = this.handleFolderPushData(folder_Json);

    if (folder) {
      storeLocalCallback(folder);
      //Santhiya added the if else condition of share or root folder to the respective rootfolder
      let params;
      if (rootFolder.name == 'Share') {
        params = Object.assign({}, this.configApiService.driveApi.pushShareFolder.params, this.licenceClientDB, { "userid": this.configureService.getLoginUserID(), "folder": folder, "action": "create", "appCode": this.configApiService.currentDriveApp['app_code'] });
      } else {
        // code changed for create folder @prabha 13/03/2020
        params = Object.assign({}, this.configApiService.driveApi.pushFolder.params, this.licenceClientDB, { "userid": this.configureService.getLoginUserID(), "folder": folder, "action": "create", "appCode": this.configApiService.currentDriveApp['app_code'] });
      }
      //let params = Object.assign( {}, this.configApiService.driveApi.pushFolder.params, {"userid":this.configureService.getLoginUserID(), "folder":folder,"action":"create"});
      this.epcDriveConect(this.pushFolder, params, synccallback);
    }
  }

  /* * * * * *
  * push Share folder    
  * * * * * */
  private pushShareFolderData(rootFolder, ffdata, currentFolder, type, storeLocalCallback, synccallback) {
    let folder = this.createShareFolder(currentFolder, ffdata, []);
    return storeLocalCallback(folder);
  }

  /* * * * * *
  * push Smart folder    
  * * * * * */
  private pushSmartFolderData(rootFolder, ffdata, currentFolder, type, storeLocalCallback, synccallback) {
    let createdFolder = this.createSmartFolder(this.objCurrentFolder, ffdata.fileName, ffdata.filterParams);
    /*
    let rootFolderId = this.objCurrentFolder['path'].length;
    let folder_Json: any;

    if(rootFolderId <= 1){
      rootFolderId = this.objCurrentFolder.folder_id;  
    }else{
      rootFolderId = this.objCurrentFolder['path'][1];
    }
     
    
    let currentRootFolder;
    for(let i=0; i < rootFolder['folders'].length; i++){ 
      if(rootFolder['folders'][i].folder_id === rootFolderId){
        currentRootFolder = rootFolder['folders'][i];
        folder_Json = rootFolder['folders'][i];
      }
    } 
    console.log(currentRootFolder)
    */
    if (createdFolder) {
      // let folder_Json = this.handleFolderPushData(createdFolder);
      storeLocalCallback(createdFolder);
      let params = Object.assign({}, this.configApiService.driveApi.pushFolder.params, this.licenceClientDB, { "userid": this.configureService.getLoginUserID(), "appCode": this.configApiService.currentDriveApp['app_code'], "folder": createdFolder, "action": "create" });
      this.epcDriveConect(this.pushFolder, params, synccallback);
    }
  }

  /* * * * * *
  * push Shared Smart folder    
  * * * * * */
  private pushSharedSmartFolderData(rootFolder, ffdata, currentFolder, type, storeLocalCallback, synccallback) {
    let createdFolder = this.createSmartFolder(this.objCurrentFolder, ffdata.fileName, ffdata.filterParams);
    let rootFolderId = this.objCurrentFolder['path'].length;
    let folder_Json: any;

    if (rootFolderId <= 1) {
      rootFolderId = this.objCurrentFolder.folder_id;
    } else {
      rootFolderId = this.objCurrentFolder['path'][1];
    }

    let currentRootFolder;
    for (let i = 0; i < rootFolder['folders'].length; i++) {
      if (rootFolder['folders'][i].folder_id === rootFolderId) {
        currentRootFolder = rootFolder['folders'][i];
        folder_Json = rootFolder['folders'][i];
      }
    }
    console.log(currentRootFolder)
    folder_Json = this.handleFolderPushData(folder_Json);
    if (createdFolder) {
      storeLocalCallback(createdFolder);
      /*
      let uid = this.configureService.getLoginUserID();
      let obj = this.objFolderActionConfig;
      obj["Receiver_User_ID"] = uid;
      obj["userid"] = uid;
      obj["Status"] = "Edit";
      obj["ShareType"] = "Folder"
      obj["Shared_Folder_Json"] = folder_Json;
      
      this.postApi(this.typeOfApi.postadd,this.postaddApi,obj,synccallback);
      */
      let params = Object.assign({}, this.configApiService.driveApi.pushFolder.params, this.licenceClientDB, { "userid": this.configureService.getLoginUserID(), "appCode": this.configApiService.currentDriveApp['app_code'], "folder": createdFolder, "action": "create", "drive": "shared" });
      this.epcDriveConect(this.pushFolder, params, synccallback);
    }
  }

  /* * * * * *
  * push folder Template    
  * * * * * */
  private pushTemplateData(ffdataRef, template, currentFolder, type, storeLocalCallback, synccallback) {
    if (template) {

      if (this.storeTemplates[template]) {
        this.storeTemplates[template] = template;
      } else {
        if (template.id === "") {
          template.id = this.storeTemplates.length;
        }
        this.storeTemplates.push(template);
        storeLocalCallback(this.storeTemplates);
      }

    } else {
      storeLocalCallback(this.storeTemplates);
    }
  }

  /* * * * * *
  * push Assign Template    
  * * * * * */
  private pushAssignTemplate(ffdataRef, ffdata, currentFolder, type, storeLocalCallback, synccallback) {
    this.assignTemplate(ffdataRef, ffdata, currentFolder, storeLocalCallback, synccallback)
  }


  /* * * * * *
    * push Assign Template    
    * * * * * */
  private pushFolderProperty(ffdataRef, ffdata, currentFolder, type, storeLocalCallback, synccallback) {
    this.updateFolderProperties(ffdataRef, ffdata, currentFolder, storeLocalCallback, synccallback)
  }

  /* * * * * *
  * push Assign Template    
  * * * * * */
  private pushCustomApi(ffdataRef, ffdata, currentFolder, type, storeLocalCallback, synccallback) {
    this.objCurrentFolder['files'] = [];
    this.objCurrentFolder = this.createFile(currentFolder, JSON.parse(ffdata));
    storeLocalCallback(this.objCurrentFolder['files'])
    this.postApi(this.typeOfApi.postadd, this.postaddApi, ffdata, synccallback)
  }

  /* * * * * *
  * push post custom  api    
  * * * * * */
  private pushPostCustomApi(ffdataRef, ffdata, currentFolder, type, storeLocalCallback, synccallback) {
    this.postApi(this.typeOfApi.postadd, this.postaddApi, ffdata, synccallback)
  }

  /* * * * * *
  * push post custom  api    
  * * * * * */
  private pushPostTemplateHistorydata(templateID, ffdata, currentFolder, type, storeLocalCallback, synccallback) {
    let template = this.storeTemplates[templateID];
    ffdata.TemplateID = templateID;
    ffdata['HTMLTemplate'] = template.templateName;
    this.postApi(this.typeOfApi.postadd, this.postaddApi, ffdata, synccallback);
    /*
    let template = currentFolder['template'];
    if(template.length > 0 && ffdataRef < template.length){             
      let tempID = template[ffdataRef]['id'];
      let templateName = template[ffdataRef]['templateName'];
      if(tempID != undefined){
        ffdata.TemplateID = tempID;
        ffdata['HTMLTemplate'] = templateName;
      }
      this.postApi(this.typeOfApi.postadd,this.postaddApi,ffdata,synccallback)     
    }else{
      alert("Template data invalid !!");
    }   
    */
  }

  /* * * * * *
  * Push Traverse Folder    
  * * * * * */
  private pushTraverseFolder(ffdataRef, ffdata, currentFolder, type, storeLocalCallback, synccallback) {
    let traverseFolder = this.traverseToFolder(currentFolder, ffdata, ffdataRef)
    storeLocalCallback(traverseFolder)
  }

  /* * * * * *
  * Push Rename Folder    
  * * * * * */
  private pushRenameFolder(rootFolder, ffdata, objCurrentFolder, type, storeLocalCallback, synccallback) {
    let folder_Json: any;
    let rootFolderId: any;
    let currentFolder = ffdata['currentfolder']
    let foldername = ffdata['foldername']
    this.objCurrentFolder = objCurrentFolder
    let rootFolderLen = currentFolder['path'].length;

    if (rootFolderLen <= 1) {
      rootFolderId = currentFolder.folder_id;
      currentFolder['name'] = foldername;
      folder_Json = currentFolder;
      this.objCurrentFolder = objCurrentFolder;
    }
    else {
      rootFolderId = currentFolder['path'][1];
      let mainFolder = rootFolder['folders'];

      for (let i = 0; i < mainFolder.length; i++) {
        if (mainFolder[i].folder_id === rootFolderId) {
          folder_Json = mainFolder[i];
        }
      }
      currentFolder['name'] = foldername;
    }

    if (rootFolderLen) {
      /*
      folder_Json = this.handleFolderPushData(folder_Json);
      let uid = this.configureService.getLoginUserID();
      let obj = this.objFolderActionConfig;
      obj["Receiver_User_ID"] = uid;
      obj["userid"] = uid;
      obj["Status"] = "Edit";
      obj["User_Folder_Json"] = folder_Json;
      storeLocalCallback( this.objCurrentFolder);
      this.postApi(this.typeOfApi.postadd,this.postaddApi,obj,synccallback);
      */
      storeLocalCallback(this.objCurrentFolder);
      folder_Json = this.handleFolderPushData(folder_Json);
      let params = Object.assign({}, this.configApiService.driveApi.pushFolder.params, this.licenceClientDB, { "userid": this.configureService.getLoginUserID(), "appCode": this.configApiService.currentDriveApp['app_code'], "folder": folder_Json, "action": "update", "drive": "root" });
      this.epcDriveConect(this.pushFolder, params, synccallback);
    } else {
      alert("Please enter folder name!!");
    }
  }


  /* * * * * *
  * Push Rename shared Folder    
  * * * * * */
  private pushRenameSharedFolder(rootFolder, ffdata, objCurrentFolder, type, storeLocalCallback, synccallback) {
    // let folder_Json: any;
    let rootFolderId: any;
    let currentFolder = ffdata['currentfolder']
    let foldername = ffdata['foldername']
    this.objCurrentFolder = objCurrentFolder
    let rootFolderLen = currentFolder['path'].length;

    if (rootFolderLen <= 1) {
      rootFolderId = currentFolder.folder_id;
      currentFolder['name'] = foldername;
      // folder_Json = currentFolder;
      this.objCurrentFolder = objCurrentFolder;
    }
    else {
      rootFolderId = currentFolder['path'][1];
      let mainFolder = rootFolder['folders'];

      for (let i = 0; i < mainFolder.length; i++) {
        if (mainFolder[i].folder_id === rootFolderId) {
          // folder_Json = mainFolder[i];
        }
      }
      currentFolder['name'] = foldername;
    }

    if (rootFolderLen) {
      /*
      folder_Json = this.handleFolderPushData(folder_Json);
      let uid = this.configureService.getLoginUserID();
      let obj = this.objFolderActionConfig;
      obj["Receiver_User_ID"] = uid;
      obj["userid"] = uid;
      obj["Status"] = "Edit";
      obj["ShareType"] = "Folder"
      obj["Shared_Folder_Json"] = folder_Json;
      storeLocalCallback( this.objCurrentFolder);
      this.postApi(this.typeOfApi.postadd,this.postaddApi,obj,synccallback)
      */
      currentFolder['files'] = [];
      storeLocalCallback(this.objCurrentFolder);
      let params = Object.assign({}, this.configApiService.driveApi.pushShareFolder.params, this.licenceClientDB, { "userid": this.configureService.getLoginUserID(), "appCode": this.configApiService.currentDriveApp['app_code'], "folder": currentFolder, "action": "update", "drive": "shared" });
      this.epcDriveConect(this.pushFolder, params, synccallback);
    } else {
      alert("Please enter folder name!!");
    }

  }

  /* * * * * *
   * Push ShareInfo Folder    
   * * * * * */
  private pushShareInfoFolder(rootFolder, currentFolder, sharedinfo, type, storeLocalCallback, synccallback) {

    let rootFolderId: any;
    let folders: any;
    let rootFolderLen = currentFolder['path'].length;

    if (rootFolderLen <= 1) {
      rootFolderId = currentFolder.folder_id;
    }
    else {
      rootFolderId = currentFolder['path'][1];
      let mainFolder = rootFolder['folders'];

      mainFolder.forEach(function (folder, i) {
        if (folder.folder_id === rootFolderId) {
          mainFolder = folder;
        }
      });

    }

    if (rootFolderId) {
      currentFolder['files'] = [];
      delete currentFolder['folders'];
      let params = Object.assign({}, this.configApiService.driveApi.pushFolder.params, this.licenceClientDB, { "userid": this.configureService.getLoginUserID(), "appCode": this.configApiService.currentDriveApp['app_code'], "folder": currentFolder, "sharedinfo": sharedinfo, "action": "share", "drive": "root" });
      this.epcDriveConect(this.pushFolder, params, synccallback);

    } else {
      alert("Invalid Folder !!");
    }
  }

  /* * * * *
   * Push Copy Folder
   * * * * * * * */
  private pushCopyFolder(rootFolder, ffdata, currentFolder, type, storeLocalCallback, synccallback) {
    let folder = ffdata;//
    let srcFolder = currentFolder;
    if (folder) {
      storeLocalCallback(folder);
      let params;
      params = Object.assign({}, this.configApiService.driveApi.pushFolder.params, this.licenceClientDB, { "userid": this.configureService.getLoginUserID(), 'srcFolder': srcFolder, "folder": folder, "action": "copy", "appCode": this.configApiService.currentDriveApp['app_code'] });
      // params = Object.assign({}, this.configApiService.driveApi.pushShareFolder.params, { "userid": this.configureService.getLoginUserID(), "folder": folder, "action": "copy", "appCode": this.configApiService.currentDriveApp['app_code'] });

      this.epcDriveConect(this.pushFolder, params, synccallback);
    }
  }
  /* * * * *
   * Push Move Folder
   * * * * * * * */
  private pushMoveFolder(rootFolder, ffdata, currentFolder, type, storeLocalCallback, synccallback) {
    let folder = ffdata;//
    let srcFolder = currentFolder;

    if (folder) {
      storeLocalCallback(folder);
      let params;
      params = Object.assign({}, this.configApiService.driveApi.pushFolder.params, this.licenceClientDB, { "userid": this.configureService.getLoginUserID(), 'srcFolder': srcFolder, "folder": folder, "action": "move", "appCode": this.configApiService.currentDriveApp['app_code'] });
      // params = Object.assign({}, this.configApiService.driveApi.pushShareFolder.params, { "userid": this.configureService.getLoginUserID(), "folder": folder, "action": "copy", "appCode": this.configApiService.currentDriveApp['app_code'] });
      this.epcDriveConect(this.pushFolder, params, synccallback);
    }
  }
  /* * * * * *
 * Push Delete Folder    
 * * * * * */
  private pushDeleteFolder(rootFolder, currentFolder, objCurrentFolder, type, storeLocalCallback, synccallback) {
    let deleteFolder: any;
    // let folder_Json: any;
    let rootFolderId: any;
    let folders: any;
    this.objCurrentFolder = objCurrentFolder
    let rootFolderLen = currentFolder['path'].length;

    if (rootFolderLen <= 1) {
      rootFolderId = currentFolder.folder_id;

      folders = objCurrentFolder['folders'];
      folders.forEach(function (folder, i) {
        if (folder.folder_id === rootFolderId) {
          deleteFolder = folder;
          folders.splice(i, 1);
        }
      });

      this.objCurrentFolder['folders'] = folders;
      deleteFolder['folder_status'] = "Delete"
      // folder_Json = deleteFolder;
      this.objCurrentFolder = objCurrentFolder;
    }
    else {
      rootFolderId = currentFolder['path'][1];
      let mainFolder = rootFolder['folders'];

      mainFolder.forEach(function (folder, i) {
        if (folder.folder_id === rootFolderId) {
          mainFolder = folder;
        }
      });

      folders = objCurrentFolder['folders'];
      folders.forEach(function (folder, i) {
        if (folder.folder_id === currentFolder.folder_id) {
          folders.splice(i, 1);
        }
      });

      objCurrentFolder['folders'] = folders;
      mainFolder['folder_status'] = "Update"
      // folder_Json = mainFolder;
      this.objCurrentFolder = objCurrentFolder;
    }

    if (rootFolderId) {
      /*
      storeLocalCallback( this.objCurrentFolder);
      folder_Json = this.handleFolderPushData(folder_Json);
      let uid = this.configureService.getLoginUserID();
      let obj = this.objFolderActionConfig;
  
      obj["Receiver_User_ID"] = uid;
      obj["userid"] = uid;
      obj["Status"] = "Delete";
      obj["User_Folder_Json"] = folder_Json;   
      
      obj["userid"] = uid;
      obj["action"] = "delete";
      obj["folder"] = currentFolder;
      this.epcDriveConect(this.pushFolder,obj,synccallback);
      */
      currentFolder['files'] = [];
      storeLocalCallback(this.objCurrentFolder);
      // code commted @prabha for delete issue 13/03/2020
      //let params = Object.assign( {}, this.configApiService.driveApi.pushFolder.params, {"userid":this.configureService.getLoginUserID(), "folder":currentFolder,"action":"delete","drive":"root"});
      let params = Object.assign({}, this.configApiService.driveApi.pushFolder.params, this.licenceClientDB, { "userid": this.configureService.getLoginUserID(), "appCode": this.configApiService.currentDriveApp['app_code'], "folder": currentFolder, "action": "delete", "drive": "root" });
      this.epcDriveConect(this.pushFolder, params, synccallback);

    } else {
      alert("Invalid Folder !!");
    }
  }


  /* * * * * *
   * Push Delete shared Folder    
   * * * * * */
  private pushDeleteSharedFolder(rootFolder, currentFolder, objCurrentFolder, type, storeLocalCallback, synccallback) {
    let deleteFolder: any;
    // let folder_Json: any;
    let rootFolderId: any;
    let folders: any;
    this.objCurrentFolder = objCurrentFolder
    let rootFolderLen = currentFolder['path'].length;

    if (rootFolderLen <= 1) {
      rootFolderId = currentFolder.folder_id;

      folders = objCurrentFolder['folders'];
      folders.forEach(function (folder, i) {
        if (folder.folder_id === rootFolderId) {
          deleteFolder = folder;
          folders.splice(i, 1);
        }
      });

      this.objCurrentFolder['folders'] = folders;
      deleteFolder['folder_status'] = "Delete"
      // folder_Json = deleteFolder;
      this.objCurrentFolder = objCurrentFolder;
    }
    else {
      rootFolderId = currentFolder['path'][1];
      let mainFolder = rootFolder['folders'];

      mainFolder.forEach(function (folder, i) {
        if (folder.folder_id === rootFolderId) {
          mainFolder = folder;
        }
      });

      folders = objCurrentFolder['folders'];
      folders.forEach(function (folder, i) {
        if (folder.folder_id === currentFolder.folder_id) {
          folders.splice(i, 1);
        }
      });

      objCurrentFolder['folders'] = folders;
      mainFolder['folder_status'] = "Update"
      // folder_Json = mainFolder;
      this.objCurrentFolder = objCurrentFolder;
    }

    if (rootFolderId) {
      /*
      folder_Json = this.handleFolderPushData(folder_Json);
      let uid = this.configureService.getLoginUserID();
      let obj = this.objFolderActionConfig;
      obj["Receiver_User_ID"] = uid;
      obj["userid"] = uid;
      obj["Status"] = "Delete";
      obj["ShareType"] = "Folder"
      obj["Shared_Folder_Json"] = folder_Json;   
      storeLocalCallback( this.objCurrentFolder);
      this.postApi(this.typeOfApi.postadd,this.postaddApi,obj,synccallback)
      */
      storeLocalCallback(this.objCurrentFolder);
      currentFolder['files'] = [];
      let params = Object.assign({}, this.configApiService.driveApi.pushShareFolder.params, this.licenceClientDB, { "userid": this.configureService.getLoginUserID(), "appCode": this.configApiService.currentDriveApp['app_code'], "folder": currentFolder, "action": "delete", "drive": "shared" });
      this.epcDriveConect(this.pushFolder, params, synccallback);
    } else {
      alert("Invalid Folder !!");
    }
  }

  /* * * * * *
  method: pushData() 
  description: stores data as folder / file / template
  params:
    ffdata: file or folder to be stored
    type: type of data posted should be one of the values from typeOfData.typeFolder, typeOfData.typeFile, typeOfData.typeTemplate
    callback: method to be called on successful request
   * * * * * */

  public pushData(ffdataRef, ffdata, currentFolder, type, storeLocalCallback, synccallback) {
    this.objCurrentFolder = currentFolder;

    if (type === this.typeOfData.typeFile) {
      this.pushFolderFilesData(ffdataRef, ffdata, currentFolder, type, storeLocalCallback, synccallback);
    }

    else if (type === this.typeOfData.typeFolder) {
      this.pushFolderData(ffdataRef, ffdata, currentFolder, type, storeLocalCallback, synccallback);
    }
    else if (type === this.typeOfData.typeSharedFolder) {
      this.pushShareFolderData(ffdataRef, ffdata, currentFolder, type, storeLocalCallback, synccallback);
    }

    else if (type === this.typeOfData.typeSmartFolder) {
      this.pushSmartFolderData(ffdataRef, ffdata, currentFolder, type, storeLocalCallback, synccallback);
    }

    else if (type === this.typeOfData.typeSharedSmartFolder) {
      this.pushSharedSmartFolderData(ffdataRef, ffdata, currentFolder, type, storeLocalCallback, synccallback);
    }

    else if (type === this.typeOfData.typeTemplate) {
      this.pushTemplateData(ffdataRef, ffdata, currentFolder, type, storeLocalCallback, synccallback);
    }
    else if (type === this.typeOfData.typeAssignTemplate) {
      this.pushAssignTemplate(ffdataRef, ffdata, currentFolder, type, storeLocalCallback, synccallback);
    }

    else if (type === this.typeOfData.typeCustomApi) {
      this.pushCustomApi(ffdataRef, ffdata, currentFolder, type, storeLocalCallback, synccallback);
    }

    else if (type === this.typeOfData.typePostCustomApi) {
      this.pushPostCustomApi(ffdataRef, ffdata, currentFolder, type, storeLocalCallback, synccallback);
    }

    else if (type === this.typeOfData.typePostTemplateHistoryApi) {
      this.pushPostTemplateHistorydata(ffdataRef, ffdata, currentFolder, type, storeLocalCallback, synccallback);
    }

    else if (type === this.typeOfData.typeTraverseFolder) {
      this.pushTraverseFolder(ffdataRef, ffdata, currentFolder, type, storeLocalCallback, synccallback);
    }

    else if (type === this.typeOfData.typeRenameFolder) {
      this.pushRenameFolder(ffdataRef, ffdata, currentFolder, type, storeLocalCallback, synccallback);
    }

    else if (type === this.typeOfData.typeRenameSharedFolder) {
      this.pushRenameSharedFolder(ffdataRef, ffdata, currentFolder, type, storeLocalCallback, synccallback);
    }

    else if (type === this.typeOfData.typeDeleteFolder) {
      this.pushDeleteFolder(ffdataRef, ffdata, currentFolder, type, storeLocalCallback, synccallback);
    }

    else if (type === this.typeOfData.typeDeleteSharedFolder) {
      this.pushDeleteSharedFolder(ffdataRef, ffdata, currentFolder, type, storeLocalCallback, synccallback);
    }

    else if (type === this.typeOfData.typeShareInfoFolder) {
      this.pushShareInfoFolder(ffdataRef, ffdata, currentFolder, type, storeLocalCallback, synccallback);
    } else if (type === this.typeOfData.typeCopyFolder) {
      this.pushCopyFolder(ffdataRef, ffdata, currentFolder, type, storeLocalCallback, synccallback);
    }
    else if (type === this.typeOfData.typeMoveFolder) {
      this.pushMoveFolder(ffdataRef, ffdata, currentFolder, type, storeLocalCallback, synccallback);
    } else if (type === this.typeOfData.typeFolderProperty) {
      this.pushFolderProperty(ffdataRef, ffdata, currentFolder, type, storeLocalCallback, synccallback);
    }
    // store in folder local db
    // if found return the folder content
    // store the contents to the folder local json
    // if the api response is success mark the response in local json as per statusOfData
    // return the folder content
    // if not found, get the template params for the folder
    // call postadd api using postAPI method 

  }

  /* * * * * *
  * Delete Template
  * * * * * */
  deleteTemplate(templateID) {
    console.log('deleteTemplate', templateID);
    delete this.storeTemplates[templateID];
  }

  /* * * * * *
  * update lookup values for dynamic lookup
  * * * * * */
  updateFieldFroperties(templateID) {
    console.log('updateFieldFroperties', templateID);
    delete this.storeTemplates[templateID]['fieldProperties'];
  }

}



// WEBPACK FOOTER //
// ./src/providers/store-wrap/store-wrap.ts